module.exports = __webpack_public_path__ + "static/media/projecticon.44e2ce60.svg";